import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "col-12 col-lg-3" };
const _hoisted_3 = { class: "table" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = ["data-bs-target"];
const _hoisted_6 = { key: 0 };
const _hoisted_7 = ["data-bs-target"];
const _hoisted_8 = { class: "col-12 col-lg-9" };
const _hoisted_9 = {
    key: 0,
    class: "border-bottom pb-3 mb-3"
};
const _hoisted_10 = ["href"];
const _hoisted_11 = { class: "mb-3" };
const _hoisted_12 = ["href"];
const _hoisted_13 = { class: "form-floating mb-3" };
const _hoisted_14 = ["id"];
const _hoisted_15 = ["for"];
const _hoisted_16 = ["id"];
const _hoisted_17 = { class: "modal-dialog modal-dialog-centered modal-lg" };
const _hoisted_18 = { class: "modal-content" };
const _hoisted_19 = { class: "modal-body" };
const _hoisted_20 = { class: "form-floating mb-3" };
const _hoisted_21 = ["id"];
const _hoisted_22 = ["for"];
const _hoisted_23 = ["id"];
const _hoisted_24 = { class: "modal-dialog modal-dialog-centered modal-lg" };
const _hoisted_25 = { class: "modal-content" };
const _hoisted_26 = { class: "modal-body" };
const _hoisted_27 = { class: "form-floating mb-3" };
const _hoisted_28 = ["id"];
const _hoisted_29 = ["for"];
import { router, useForm } from '@inertiajs/vue3';
import { ref } from 'vue';
import { responseMessages } from '@/Composables/responseMessages';
import { useConfirm } from 'primevue';
import { formatters } from '@/Composables/formatters';
import { Modal } from 'bootstrap';
import Swal from 'sweetalert2';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DimensionSheetManager',
    props: {
        printConfiguration: {
            type: Object,
            required: true,
        }
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        const confirm = useConfirm();
        const uuid = ref(Math.random().toString(36).substring(2, 11));
        const dimensionSheetUploadForm = useForm({
            file: null
        });
        const adminApprovalForm = useForm({
            adminApprovedAt: null
        });
        const customerApprovalForm = useForm({
            customerApprovedAt: null
        });
        function updateAdminApprovedAt() {
            adminApprovalForm.transform((data) => ({
                admin_approved_at: data.adminApprovedAt
            })).submit('put', route('admin.dimensionSheets.updateAdminApproval', props.printConfiguration.dimensionSheet.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    const modalElement = document.getElementById('adminApprovedAt' + uuid.value);
                    if (modalElement) {
                        const modalInstance = Modal.getInstance(modalElement);
                        modalInstance?.hide();
                    }
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function updateCustomerApprovedAt() {
            customerApprovalForm.transform((data) => ({
                customer_approved_at: data.customerApprovedAt
            })).submit('put', route('admin.dimensionSheets.updateCustomerApproval', props.printConfiguration.dimensionSheet.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    const modalElement = document.getElementById('customerApprovedAt' + uuid.value);
                    if (modalElement) {
                        const modalInstance = Modal.getInstance(modalElement);
                        modalInstance?.hide();
                    }
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function uploadDimensionSheet(printConfigurationUuid) {
            dimensionSheetUploadForm.transform((data) => ({
                file: data.file
            }))
                .submit('post', route('admin.dimensionSheets.uploadExistingDimensionSheet', printConfigurationUuid), {
                preserveScroll: true,
                onSuccess: page => {
                    dimensionSheetUploadForm.reset();
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function removeManualDimensionSheet(dimensionSheetUuid) {
            confirm.require({
                message: 'Soll das manuell hochgeladene Maßblatt wirklich gelöscht werden?',
                header: 'Maßblatt löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.dimensionSheets.destroyFileUpload', dimensionSheetUuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function generateDimensionSheet() {
            let timerInterval;
            Swal.fire({
                title: "Einen Moment bitte!",
                html: "Maßblatt wird generiert: <b></b> Sekunden.",
                timer: 60000,
                timerProgressBar: true,
                didOpen: () => {
                    Swal.showLoading();
                    const timer = Swal.getPopup().querySelector("b");
                    timerInterval = setInterval(() => {
                        timer.textContent = `${(Swal.getTimerLeft() / 1000).toFixed(0)}`;
                    }, 100);
                },
                willClose: () => {
                    clearInterval(timerInterval);
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _cache[23] || (_cache[23] = _createElementVNode("h4", { class: "bg-primary text-white px-3 py-2 mb-4" }, "Maßblatt", -1)),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _cache[12] || (_cache[12] = _createElementVNode("p", null, "Min. eine Freigabe muss erfolgen.", -1)),
                        _createElementVNode("table", _hoisted_3, [
                            _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                    _cache[9] || (_cache[9] = _createElementVNode("th", null, "Admin-Freigabe", -1)),
                                    _createElementVNode("td", null, _toDisplayString(props.printConfiguration.dimensionSheet && props.printConfiguration.dimensionSheet.adminApprovedAt ? _unref(formatDate)(props.printConfiguration.dimensionSheet.adminApprovedAt, true) + ' Uhr' : '-'), 1),
                                    (props.printConfiguration.dimensionSheet)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
                                            _createElementVNode("button", {
                                                class: "btn btn-sm btn-secondary d-inline-flex align-items-center",
                                                "data-bs-toggle": "modal",
                                                "data-bs-target": '#adminApprovedAt' + uuid.value
                                            }, [...(_cache[8] || (_cache[8] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-check2",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                    ], -1),
                                                    _createElementVNode("span", { class: "ms-2" }, "Freigabe", -1)
                                                ]))], 8, _hoisted_5)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("tr", null, [
                                    _cache[11] || (_cache[11] = _createElementVNode("th", null, "Kunden-Freigabe", -1)),
                                    _createElementVNode("td", null, _toDisplayString(props.printConfiguration.dimensionSheet && props.printConfiguration.dimensionSheet.customerApprovedAt ? _unref(formatDate)(props.printConfiguration.dimensionSheet.customerApprovedAt, true) + ' Uhr' : '-'), 1),
                                    (props.printConfiguration.dimensionSheet)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                                            _createElementVNode("button", {
                                                class: "btn btn-sm btn-secondary d-inline-flex align-items-center",
                                                "data-bs-toggle": "modal",
                                                "data-bs-target": '#customerApprovedAt' + uuid.value
                                            }, [...(_cache[10] || (_cache[10] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-check2",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                    ], -1),
                                                    _createElementVNode("span", { class: "ms-2" }, "Freigabe", -1)
                                                ]))], 8, _hoisted_7)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        (props.printConfiguration.dimensionSheet && props.printConfiguration.dimensionSheet.hasManualUploadedFile)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _cache[15] || (_cache[15] = _createElementVNode("p", null, "Ein Maßblatt wurde bereits manuell hochgeladen!", -1)),
                                _createElementVNode("a", {
                                    href: _ctx.route('admin.dimensionSheets.download', props.printConfiguration.dimensionSheet.uuid),
                                    class: "btn btn-primary text-white d-inline-flex align-items-center me-3 mb-3 mb-md-0"
                                }, [...(_cache[13] || (_cache[13] = [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            height: "16",
                                            fill: "currentColor",
                                            class: "bi bi-file-earmark-pdf",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", { d: "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" }),
                                            _createElementVNode("path", { d: "M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" })
                                        ], -1),
                                        _createElementVNode("span", { class: "ms-2" }, "Download (manueller Upload)", -1)
                                    ]))], 8, _hoisted_10),
                                _createElementVNode("button", {
                                    class: "btn btn-danger d-inline-flex align-items-center",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (removeManualDimensionSheet(props.printConfiguration.dimensionSheet.uuid)))
                                }, [...(_cache[14] || (_cache[14] = [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            fill: "currentColor",
                                            class: "bi bi-x-circle",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                            _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                        ], -1),
                                        _createElementVNode("span", { class: "ms-2" }, "Upload löschen", -1)
                                    ]))])
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("a", {
                                href: _ctx.route('admin.dimensionSheets.edit', props.printConfiguration.uuid),
                                onClick: _cache[1] || (_cache[1] = ($event) => (generateDimensionSheet())),
                                class: "btn btn-primary text-white d-inline-flex align-items-center"
                            }, [...(_cache[16] || (_cache[16] = [
                                    _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "currentColor",
                                        class: "bi bi-file-earmark-image",
                                        viewBox: "0 0 16 16"
                                    }, [
                                        _createElementVNode("path", { d: "M6.502 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" }),
                                        _createElementVNode("path", { d: "M14 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zM4 1a1 1 0 0 0-1 1v10l2.224-2.224a.5.5 0 0 1 .61-.075L8 11l2.157-3.02a.5.5 0 0 1 .76-.063L13 10V4.5h-2A1.5 1.5 0 0 1 9.5 3V1z" })
                                    ], -1),
                                    _createElementVNode("span", { class: "ms-2" }, "Maßblatt generieren", -1)
                                ]))], 8, _hoisted_12)
                        ]),
                        _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-secondary" }, "oder Maßblatt manuell hochladen", -1)),
                        _createElementVNode("div", null, [
                            _createElementVNode("form", {
                                onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event) => (uploadDimensionSheet(props.printConfiguration.uuid)), ["prevent"])),
                                enctype: "multipart/form-data"
                            }, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("input", {
                                        type: "file",
                                        onInput: _cache[2] || (_cache[2] = ($event) => (_unref(dimensionSheetUploadForm).file = $event.target.files[0])),
                                        class: "form-control",
                                        id: 'dimensionSheetUpload' + uuid.value
                                    }, null, 40, _hoisted_14),
                                    _createElementVNode("label", {
                                        for: 'dimensionSheetUpload' + uuid.value
                                    }, "Neues Maßblatt", 8, _hoisted_15)
                                ]),
                                _cache[17] || (_cache[17] = _createStaticVNode("<button type=\"submit\" class=\"btn btn-success d-inline-flex align-items-center\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-cloud-upload\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383\"></path><path fill-rule=\"evenodd\" d=\"M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708z\"></path></svg><span class=\"ms-2\">Upload</span></button>", 1))
                            ], 32)
                        ])
                    ])
                ]),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createElementVNode("div", {
                        class: "modal fade",
                        id: 'adminApprovedAt' + uuid.value,
                        tabindex: "-1",
                        "aria-labelledby": "adminApprovedAtModalLabel",
                        "aria-hidden": "true"
                    }, [
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("h1", { class: "modal-title fs-5 fw-bold" }, "Admin-Freigabe"),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    })
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event) => (updateAdminApprovedAt()), ["prevent"]))
                                }, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("div", _hoisted_20, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "date",
                                                class: "form-control",
                                                id: 'adminApprovedAtDate' + uuid.value,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(adminApprovalForm).adminApprovedAt) = $event)),
                                                required: ""
                                            }, null, 8, _hoisted_21), [
                                                [_vModelText, _unref(adminApprovalForm).adminApprovedAt]
                                            ]),
                                            _createElementVNode("label", {
                                                for: 'adminApprovedAtDate' + uuid.value
                                            }, "Datum", 8, _hoisted_22)
                                        ])
                                    ]),
                                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-secondary",
                                            "data-bs-dismiss": "modal"
                                        }, "Abbrechen"),
                                        _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ])
                                    ], -1))
                                ], 32)
                            ])
                        ])
                    ], 8, _hoisted_16)
                ])),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createElementVNode("div", {
                        class: "modal fade",
                        id: 'customerApprovedAt' + uuid.value,
                        tabindex: "-1",
                        "aria-labelledby": "customerApprovedAtModalLabel",
                        "aria-hidden": "true"
                    }, [
                        _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("h1", { class: "modal-title fs-5 fw-bold" }, "Kunden-Freigabe"),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    })
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event) => (updateCustomerApprovedAt()), ["prevent"]))
                                }, [
                                    _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("div", _hoisted_27, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "date",
                                                class: "form-control",
                                                id: 'customerApprovedAtDate' + uuid.value,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(customerApprovalForm).customerApprovedAt) = $event)),
                                                required: ""
                                            }, null, 8, _hoisted_28), [
                                                [_vModelText, _unref(customerApprovalForm).customerApprovedAt]
                                            ]),
                                            _createElementVNode("label", {
                                                for: 'customerApprovedAtDate' + uuid.value
                                            }, "Datum", 8, _hoisted_29)
                                        ])
                                    ]),
                                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-secondary",
                                            "data-bs-dismiss": "modal"
                                        }, "Abbrechen"),
                                        _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ])
                                    ], -1))
                                ], 32)
                            ])
                        ])
                    ], 8, _hoisted_23)
                ]))
            ], 64));
        };
    }
});
